var _style, _g, _path, _path2, _path3, _g2, _g3, _g4, _g5, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FBECD5;}\n\t.st1{fill:#666666;}\n\t.st2{fill:#F8F1E3;}\n\t.st3{fill:none;stroke:#666666;stroke-width:0.9225;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st4{fill:none;stroke:#666666;stroke-width:2.044;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st5{fill:#FFFFFF;stroke:#666666;stroke-width:2.0792;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st6{fill:#F8D6E3;}\n\t.st7{fill:none;stroke:#666666;stroke-width:1.7683;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st8{fill:#FFFFFF;stroke:#666666;stroke-width:0.9293;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st9{fill:none;stroke:#000000;stroke-width:1.1992;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st10{fill:none;stroke:#808080;stroke-width:1.0238;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st11{fill:none;stroke:#808080;stroke-width:1.0195;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st12{fill:none;stroke:#808080;stroke-width:1.2379;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st13{fill:none;stroke:#808080;stroke-width:0.9903;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100,230.1V241c0,0,16.8,4.8,7.1,18.7c0,0-1.8,3.7-7.4,3V274l140.9-11.8l-0.5-47L100,230.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100.4,230.1l0.1,10.8l-0.1-0.1c2,0.6,3.8,1.5,5.5,2.7c1.7,1.2,3.2,2.7,4.1,4.6c0.9,1.9,1,4.1,0.5,6.1 c-0.5,2-1.5,3.9-2.7,5.6l0,0c-0.4,0.7-0.9,1.2-1.5,1.7c-0.6,0.5-1.2,0.8-1.9,1.1c-0.7,0.2-1.4,0.4-2.2,0.5c-0.4,0-0.7,0-1.1,0 l-1.1-0.1l0.5-0.4l0.1,11.3l-0.6-0.5l35.2-3.1l35.2-3.1l70.4-6l-0.9,1l-0.4-47l1,0.9l-34.9,3.6l-35,3.5L100.4,230.1z  M100.4,230.1l69.8-8l35.1-4l35.2-3.9c0.5-0.1,0.9,0.3,1,0.8c0,0,0,0.1,0,0.1l0.5,47c0,0.5-0.4,0.9-0.9,1l-70.5,5.8l-35.2,2.8 l-35.2,2.7l0,0c-0.3,0-0.5-0.2-0.6-0.5l0,0l0.1-11.3c0-0.2,0.2-0.4,0.4-0.4l0,0l0,0l1,0.1c0.3,0,0.7,0,1,0c0.7,0,1.3-0.2,2-0.4 c0.6-0.2,1.2-0.5,1.7-1c0.5-0.4,1-0.9,1.3-1.4l0,0l0,0c1.2-1.6,2.1-3.4,2.7-5.3c0.5-1.9,0.5-4-0.3-5.8c-0.8-1.8-2.2-3.3-3.8-4.5 c-1.6-1.2-3.5-2.1-5.4-2.7l0,0c-0.1,0-0.1-0.1-0.1-0.1L100.4,230.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M92.6,228.6l54.7-31.1c0,0,20.1,4.4,21.4-5.5c0,0-3-2.8-7.4-3l10.8-5.5l14.1,6.7c0,0-1.2,6.5,10.8,5.8 l35.7,17.8L92.6,228.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100,229.1c8.9-5.1,17.9-10.4,27-15.7c9-5.3,18.2-10.7,27.4-16c0.1-0.1,0.3-0.1,0.4-0.1l0,0 c2,0.4,4,0.6,6,0.8c2,0.1,4,0.2,6,0c2-0.2,3.9-0.6,5.6-1.5c1.7-0.9,2.8-2.4,3-4.2l0.2,0.7c-0.4-0.4-1-0.8-1.5-1.1 c-0.5-0.3-1.1-0.6-1.7-0.8c-1.2-0.5-2.4-0.8-3.7-0.8l0,0c-0.5,0-0.8-0.4-0.8-0.9c0-0.3,0.2-0.6,0.4-0.7l10.8-5.6 c0.2-0.1,0.5-0.1,0.8,0l14.1,6.7c0.4,0.2,0.5,0.5,0.5,0.9l0,0.1c0,0.3,0,0.9,0.2,1.3c0.1,0.4,0.4,0.8,0.7,1.2 c0.6,0.7,1.5,1.2,2.5,1.6c1,0.3,2.1,0.5,3.2,0.6c1.1,0.1,2.2,0.1,3.4,0l0,0c0.2,0,0.3,0,0.4,0.1l17.9,8.8l17.9,8.9 c0.5,0.2,0.7,0.8,0.4,1.2c-0.1,0.3-0.4,0.5-0.7,0.5l-35.3,3.7c-11.8,1.2-23.6,2.4-35.3,3.5l-35,3.4L100,229.1z M100,229.1l35.4-4 l35.1-4.1c11.7-1.4,23.3-2.7,34.8-4l34.8-3.8l-0.3,1.8l-17.9-8.8l-17.9-8.9l0.5,0.1c-1.2,0-2.4,0.1-3.6,0 c-1.2-0.1-2.4-0.3-3.6-0.7c-1.2-0.4-2.4-1.1-3.3-2.1c-0.4-0.5-0.8-1.2-1-1.8c-0.2-0.7-0.3-1.3-0.2-2.1l0.5,1l-14.1-6.7l0.8,0 l-10.9,5.5l-0.3-1.6c1.4,0.1,2.9,0.4,4.2,1c0.7,0.3,1.3,0.6,1.9,1c0.6,0.4,1.2,0.8,1.8,1.3c0.2,0.2,0.3,0.4,0.3,0.7l0,0 c-0.2,1.1-0.6,2.2-1.3,3.2c-0.7,0.9-1.6,1.6-2.6,2.2c-2,1.1-4.1,1.4-6.2,1.6c-2.1,0.2-4.2,0.1-6.2,0c-2.1-0.2-4.1-0.5-6.1-0.9 l0.4-0.1c-9.1,5.1-18.1,10.1-27.3,15.2C118.5,218.7,109.3,223.8,100,229.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M125.1,242.4c-0.3,1.6-0.4,3.4,0.7,4.5c1,1.1,2.7,1.2,4.1,1c1.4-0.1,2.9-0.4,4.3-0.8c1.5-0.4,3-1.1,3.5-2.6 c0.6-1.8-0.9-3.5-2.3-4.8c-1.7-1.5-4.1-4-6.5-3.3C126.3,237.2,125.4,240.3,125.1,242.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M183.3,256.3c2.8,4.9,12.2,1.2,8.5-4.5C189,247.5,180.6,251.6,183.3,256.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M218.2,243.4c-0.6,2.4-0.6,5.2,1,7.1c0.9,1,2.1,1.6,3.4,2c2.3,0.6,4.8,0.2,6.7-1.2c1.9-1.4,3-3.9,2.6-6.2 C230.5,238.3,220.1,235.6,218.2,243.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M147,211c-1.8-0.4-3.6-0.6-5.5-0.4c-0.4,0-0.7,0.1-1.1,0.2c-0.3,0.2-0.6,0.5-0.8,0.9c-1,2,0,4.8,2.1,5.7 c2.1,1,4.7,0.1,6-1.8c0.5-0.8,0.8-1.8,0.7-2.7c-0.2-0.9-0.9-1.8-1.9-2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M183.2,205.8c-0.4,1.9,0,4.2,1.6,5.3c1.1,0.8,2.5,1,3.8,1c1.7,0,3.4-0.2,5-0.7c0.4-0.1,0.8-0.3,1.1-0.5 c0.4-0.3,0.6-0.8,0.7-1.2c0.7-2.1,0.4-4.6-0.7-6.5C191.3,197.4,184.5,199.9,183.2,205.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M140.3,270.3c-0.4-1.6-0.6-3.2-0.8-4.8l0,0l0,0c-0.1-1.8-0.1-3.5,0-5.3c0-0.9,0.1-1.8,0.1-2.6 c0.1-0.9,0.2-1.8,0.3-2.6c0.1,0.9,0.2,1.8,0.3,2.6c0.1,0.9,0.1,1.8,0.1,2.6c0.1,1.8,0.1,3.5,0,5.3l0,0 C140.4,267,140.4,268.6,140.3,270.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M206.9,244.5c-0.8-1.9-1.4-3.9-1.8-5.9c-0.3-2.1-0.4-4.1-0.8-6.1c-0.4-2-0.7-4.1-0.9-6.1 c-0.2-2-0.3-4.1-0.2-6.2c0,0,0,0,0,0c0,0,0,0,0,0c0.5,2,0.9,4,1.1,6.1c0.2,2,0.4,4.1,0.4,6.2c0,1,0.1,2.1,0.3,3.1 c0.2,1,0.5,2,0.8,3C206.4,240.4,206.8,242.4,206.9,244.5C207,244.5,207,244.5,206.9,244.5C206.9,244.5,206.9,244.5,206.9,244.5z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M187,147.7c0,0,14.5,47,10.6,62c0,0,2.6,1.3,11.1,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M170.1,147.7c0,0-7.7,28.2-9.7,38.5c-1.3,6.9,1.4,19.6,1.4,19.6s-10.7-1.1-12.4,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M179.1,160.7l-16.2-0.1c-3.9-0.7-4.7-1.6-5.9-2.7c-5.2-5.4,13.5-62.2,13.5-62.2l18,0.1c0,0,17.9,57,12.6,62.4 c-1.1,1.2-2,2-5.9,2.7L179.1,160.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M171.9,96.2"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 180.6,
    cy: 82.8,
    r: 20.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M192.2,106.1c0,0,15.4,26.8,20.2,33.7c0.5,0.8,0.2,1.8-0.7,2.1c-2.5,0.8-7,2.1-8.9,2.2 c-4.4,0.2-16.9-2.6-16.1,6.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M162.3,121.4l-1,1.7c-1.3,2.2-4.4,2.2-5.8,0.1l-3.7-28.6c0,0-8.9-6.6-4.3-14.8"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st6",
    points: "177.3,114.9 184.7,141.8 177.3,152.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6",
    points: "177.3,117 171.7,142.4 177.3,152.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "178.6,108 185.6,139.3 178.6,151.4  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "178.6,108 171.7,139.3 178.6,151.4  "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 178.6,
    cy: 108,
    r: 2.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 178.6,
    cy: 107.1,
    r: 3.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M166.4,76.6h14.3c0,0,7.1-0.7,7,7.2c0,0,0.7,5.8-11.4,7.3l-9.3,1.5C167,92.6,166.8,76.6,166.4,76.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M150.8,76.3l15.7,0.1c0,0,1.4,0.7,1.2,2.7l-2.3,9.5l-14.2,2.7L150.8,76.3z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 149.6,
    cy: 84.1,
    rx: 7.9,
    ry: 8.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 165.6,
    cy: 85.1,
    rx: 7.9,
    ry: 8.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st6",
    cx: 149.6,
    cy: 84.1,
    rx: 6.1,
    ry: 6.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st6",
    cx: 165.6,
    cy: 85.1,
    rx: 6.1,
    ry: 6.6
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M180.7,44.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M136.5,26.6c-0.2,2.4,1.5,4.7,3.1,4.1c1.6-0.6,2.4-3.8,1.5-5.8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M195.1,52.5c-3-0.1-5.3-3.5-4.4-6.3c1-2.8,4.9-4.1,7.3-2.3c2.4,1.8,2.4,5.9,0,7.7c-1.2,0.2-2.3,0.5-3.5,0.7"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 121.8,
    y1: 113.8,
    x2: 114.7,
    y2: 121
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 114.7,
    y1: 113.8,
    x2: 121.8,
    y2: 121
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 98.2,
    y1: 58.4,
    x2: 92.5,
    y2: 64.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 92.5,
    y1: 58.4,
    x2: 98.2,
    y2: 64.1
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 116.8,
    y1: 170.1,
    x2: 109.6,
    y2: 177.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 109.6,
    y1: 170.1,
    x2: 116.8,
    y2: 177.3
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 247.5,
    y1: 133.7,
    x2: 241.7,
    y2: 139.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 241.7,
    y1: 133.7,
    x2: 247.5,
    y2: 139.4
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M238.1,79.8c-1.4-1.1-3.8-0.9-4.9,0.6c-1.1,1.4-0.9,3.7,0.5,4.9s3.7,0.9,4.9-0.5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M291.6,112.8c-0.7-3.1,1.7-6.5,4.8-6.8c0.7-0.1,1.3,0.6,1.7,1.2c1.1,1.7,1.9,3.9,1.2,5.9 S293.4,113.9,291.6,112.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M41.6,87c-3,0.1-5.3,3.5-4.4,6.3c1,2.8,4.9,4.1,7.3,2.3c2.4-1.8,2.4-5.9,0-7.7c-1.2-0.2-2.3-0.5-3.5-0.7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M68.8,131.8c-3,0.1-5.3,3.5-4.4,6.3c1,2.8,4.9,4.1,7.3,2.3c2.4-1.8,2.4-5.9,0-7.7c-1.2-0.2-2.3-0.5-3.5-0.7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M248.6,183.9c-3,0.1-5.3,3.5-4.4,6.3c1,2.8,4.9,4.1,7.3,2.3c2.4-1.8,2.4-5.9,0-7.7c-1.2-0.2-2.3-0.5-3.5-0.7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M9.7,156c-2,0.3-5.3,5.7-7.3,5.1c0.6-4.1,1.2-8.2,1.7-12.2c2.2,1.9,3.1,4,5.2,5.9C9.9,155.2,9.6,156.6,9.7,156 z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M288.2,189.4c-2,0.3-5.3,5.7-7.3,5.1c0.6-4.1,1.2-8.2,1.7-12.2c2.2,1.9,3.1,4,5.2,5.9 C288.4,188.6,288.1,190,288.2,189.4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M62.8,198.5c-2,0.3-5.3,5.7-7.3,5.1c0.6-4.1,1.2-8.2,1.7-12.2c2.2,1.9,3.1,4,5.2,5.9 C63,197.7,62.7,199.1,62.8,198.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyMessage);
export default __webpack_public_path__ + "static/media/emptyMessage.7aebc2b4ec4bbd55107b9c687f9c2768.svg";
export { ForwardRef as ReactComponent };